webpackJsonp([22459908527388],{

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(15);
	
	__webpack_require__(8);
	
	__webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'Hero' },
	        _react2.default.createElement(
	            'div',
	            { className: 'HeroGroup' },
	            _react2.default.createElement(
	                'h1',
	                null,
	                'McDonald\'s Vending Machine'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Developed In 2019'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'video' },
	            _react2.default.createElement(
	                'center',
	                null,
	                _react2.default.createElement('iframe', { width: '560', height: '315', src: 'https://www.youtube.com/embed/AxFQUdMKyzg', frameborder: '0', allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture', allowfullscreen: true })
	            ),
	            _react2.default.createElement(
	                'h5',
	                { className: 'align' },
	                'Project Name:'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'title' },
	                _react2.default.createElement(
	                    'h5',
	                    { className: 'align' },
	                    'McDonald\'s Vending Machine'
	                )
	            ),
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(
	                'h5',
	                { className: 'align' },
	                'Description:'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'title' },
	                _react2.default.createElement(
	                    'h5',
	                    { className: 'align' },
	                    'This project is designed to be a prototype of self-serving vending machine for McDonald\'s. The main functions of this prototype is to allow customers to order via the online store and automatically dispense food to customers. This prototype is aimed at reducing the workload of workers at McDonald\'s and minimizing the wait time for customers.'
	                ),
	                _react2.default.createElement(
	                    'h5',
	                    { className: 'align' },
	                    'This project was submitted as Johns Hopkins Center for Talented Youth (CTY) Online Program course "Introduction to Computer Science and Engineering" Final Project. Here are the comments from the CTY instructor, Mr. Jason Bodary:"I am very impressed. And your project was quite complex and VERY well done. Your diagrams and videos were awesone! And the code you created was very well thought out. A+ work all around!" '
	                )
	            )
	        )
	    );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-mc-js-ae7ebdcebb4658a497b4.js